import cryptoRandomString from 'crypto-random-string'

export const startFileDownload = (localFile, remote, setDownloadProgress = () => {}) => {
  const fileTransfer = new window.FileTransfer()
  const remoteUri = encodeURI(remote)
  const localUri = localFile.toURL()

  return new Promise((resolve, reject) => {
    fileTransfer.onprogress = (progressEvent) => {
      if (progressEvent.lengthComputable) {
        const percentage = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(0)
        setDownloadProgress(percentage)
      }
    }

    fileTransfer.download(
      remoteUri,
      localUri,
      (downloadedSong) => resolve(downloadedSong.toURL()),
      (error) => reject('Download error code: ' + error.code),
      false
    )
  })
}

export const getFileDestination = (fileName, directory, options = {}) => {
  return new Promise((resolve, reject) => {
    directory.getFile(fileName, options, resolve, reject)
  })
}

export const getDirectoryDestination = (type, dirName, options = {}) => {
  return new Promise((resolve, reject) => {
    window.requestFileSystem(
      type,
      0,
      (fileSystem) => {
        fileSystem.root.getDirectory(dirName, options, resolve, reject)
      },
      (err) => (console.log('Error: ', err), reject(err))
    )
  })
}

export const moveFromTempToDownloaded = (fileName, sourceDir, destDir = 'songs') => {
  return new Promise((resolve, reject) => {
    sourceDir.getFile(fileName, {}, async (fileToMove) => {
      // Get fs for destination in persistent storage
      const permSongsDir = await getDirectoryDestination(window.PERSISTENT, destDir)
      fileToMove.moveTo(
        permSongsDir,
        fileName,
        (res) => {
          console.log('Copying was successful to: ' + res.nativeURL)
          resolve(res.nativeURL)
        },
        reject
      )
    })
  })
}

export const moveFromTempCompanyLogoToDownloaded = (
  fileName,
  sourceDir,
  destDir = 'companyLogo'
) => {
  return new Promise((resolve, reject) => {
    sourceDir.getFile(fileName, {}, async (fileToMove) => {
      // Get fs for destination in persistent storage
      const permCompanyLogoDir = await getDirectoryDestination(
        window.PERSISTENT,
        destDir,
        { create: true }
      )
      fileToMove.moveTo(
        permCompanyLogoDir,
        fileName,
        (res) => {
          console.log('Copying was successful to: ' + res.nativeURL)
          resolve(res.nativeURL)
        },
        reject
      )
    })
  })
}

export const removeFile = async (fileName) => {
  const persistentDirectoryDestination = await getDirectoryDestination(
    window.PERSISTENT,
    'songs'
  )

  return new Promise((resolve, reject) => {
    persistentDirectoryDestination.getFile(fileName, {}, (fileEntry) => {
      fileEntry.remove(
        resolve,
        () => reject('COULD_NOT_REMOVE_FILE'),
        () => reject('COULD_NOT_REMOVE_FILE')
      )
    })
  })
}

export const removeTmpFile = async (fileName) => {
  const persistentDirectoryDestination = await getDirectoryDestination(
    window.PERSISTENT,
    'tempSongs'
  )

  return new Promise((resolve, reject) => {
    persistentDirectoryDestination.getFile(fileName, {}, (fileEntry) => {
      fileEntry.remove(
        resolve,
        () => reject('COULD_NOT_REMOVE_FILE'),
        () => reject('COULD_NOT_REMOVE_FILE')
      )
    })
  })
}

export const removeTmpCompanyLogoFile = async (fileName) => {
  const persistentDirectoryDestination = await getDirectoryDestination(
    window.PERSISTENT,
    'tempCompanyLogo'
  )

  return new Promise((resolve, reject) => {
    persistentDirectoryDestination.getFile(fileName, {}, (fileEntry) => {
      fileEntry.remove(
        resolve,
        () => reject('COULD_NOT_REMOVE_FILE'),
        () => reject('COULD_NOT_REMOVE_FILE')
      )
    })
  })
}

export const createOrAccessExistingDirectory = (type, dirName) => {
  const dirAccessSuccessCb = (resolve, reject) => (songsDirectory) => {
    const reader = songsDirectory.createReader()
    reader.readEntries(
      (fileEntries) => resolve(fileEntries),
      (err) => (console.log('Error: ', err), reject())
    )
  }

  return new Promise((resolve, reject) =>
    window.requestFileSystem(type, 0, (fs) => {
      fs.root.getDirectory(
        dirName,
        // Only create and access directory if it does not exist
        { create: true, exclusive: true },
        dirAccessSuccessCb(resolve, reject),
        ({ code }) => {
          if (code !== FileError.PATH_EXISTS_ERR) reject('Error: ' + code)
          // Since directory exists, access it again without creating it
          fs.root.getDirectory(
            dirName,
            // Since directory exists, access it
            {},
            dirAccessSuccessCb(resolve, reject),
            (err) => (console.log('Error: ', err), reject())
          )
        }
      )
    })
  )
}

export const initializeBlobAudio = async (input, output, cdvPath) => {
  await decryptAudioFile(input, output)
  const fileEntry = await createFileEntryAudio(cdvPath)

  return new Promise((resolve, reject) => {
    fileEntry.file(
      (file) => {
        const reader = new FileReader()

        reader.onloadend = function () {
          const blob = new Blob([new Uint8Array(this.result)], { type: 'audio/mp3' })
          const url = window.URL.createObjectURL(blob)
          resolve(url)
        }

        reader.readAsArrayBuffer(file)
      },
      () => {
        reject('Error when loading file audio')
      }
    )
  })
}

export const createFileEntryAudio = (cdvPath) => {
  return new Promise((resolve, reject) => {
    window.resolveLocalFileSystemURL(
      `cdvfile://localhost/persistent/${cdvPath}`,
      (fileEntry) => {
        resolve(fileEntry)
      },
      reject
    )
  })
}

export const encryptAudioFile = async (input, output) => {
  const isCryptoIntialized = JSON.parse(localStorage.getItem('songsInitialized'))
  let key
  let IV

  if (isCryptoIntialized) {
    key = await getSecureKey('key')
    IV = await getSecureKey('IV')
  } else {
    localStorage.setItem('songsInitialized', true)
    key = await generateSecureKey()
    IV = await generateSecureKey()
    await setSecureKey('key', key)
    await setSecureKey('IV', IV)
  }

  return new Promise((resolve, reject) => {
    const safe = window.cordova.plugins.disusered.safe

    const success = (encryptedFile) => {
      resolve(encryptedFile)
    }

    safe.encrypt(input, output, key, IV, success, reject)
  })
}

export const decryptAudioFile = async (input, output) => {
  const key = await getSecureKey('key')
  const IV = await getSecureKey('IV')

  return new Promise((resolve, reject) => {
    const safe = window.cordova.plugins.disusered.safe

    const success = (decryptedFile) => {
      resolve(decryptedFile)
    }

    safe.decrypt(input, output, key, IV, success, reject)
  })
}

export const generateSecureKey = () => {
  return new Promise((resolve, reject) => {
    try {
      const key = cryptoRandomString({ length: 32 })
      resolve(key)
    } catch (e) {
      reject()
    }
  })
}

export const setSecureKey = async (alias, key) => {
  return new Promise((resolve, reject) => {
    window.cordova.plugins.SecureKeyStore.set(
      (result) => {
        resolve(result)
      },
      (error) => {
        reject(error)
      },
      alias,
      key
    )
  })
}

export const getSecureKey = (alias) => {
  return new Promise((resolve, reject) => {
    window.cordova.plugins.SecureKeyStore.get(
      (result) => {
        resolve(result)
      },
      (error) => {
        reject(error)
      },
      alias
    )
  })
}
